import type { ReactNode } from 'react';
import { Link, type LinkProps } from 'react-router';
import { buttonClassName, type ButtonSize, type ButtonVariant } from '@/components/ui';

export interface LinkButtonProps extends LinkProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
  leftIcon?: ReactNode;
}

/** A router link styled as a button (for navigation actions). */
export function LinkButton({
  variant = 'secondary',
  size = 'md',
  leftIcon,
  className,
  children,
  ...props
}: LinkButtonProps) {
  return (
    <Link
      {...props}
      className={buttonClassName({
        variant,
        size,
        className: typeof className === 'string' ? className : undefined,
      })}
    >
      {leftIcon && (
        <span aria-hidden="true" style={{ display: 'inline-flex' }}>
          {leftIcon}
        </span>
      )}
      <span>{children as ReactNode}</span>
    </Link>
  );
}
